import React from 'react'
import styled from 'styled-components'
import { useTheme } from '@mui/material/styles'
import { TOPBAR_MOBILE_HEIGHT } from '@/v2/constants'
import SettingsMenu from '@/v2/components/common/SettingsMenu'
import ClinicSwitcher from '@/v2/containers/sidebar/ClinicSwitcher'

const Wrapper = styled.div`
  height: ${TOPBAR_MOBILE_HEIGHT};
  border-bottom: 1px solid ${({ theme }) => theme.divider.main};
  padding: 18px;
  padding-left: calc(18px + env(safe-area-inset-left));
  padding-right: calc(18px + env(safe-area-inset-right));
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
`

const Buttons = styled.div``

const TopbarMobile = () => {
  const theme = useTheme()
  return (
    <Wrapper theme={theme.palette}>
      <ClinicSwitcher />
      <Buttons>
        <SettingsMenu />
      </Buttons>
    </Wrapper>
  )
}

export default TopbarMobile
